import React from 'react';
import { Box, Text, Button, Grid, Link, VStack } from '@chakra-ui/react';
import { ProjectContext } from "../ThemeProvider";
import { noop } from "../../utils";
export var SuccessFeedback = function SuccessFeedback(props) {
  var isBankTransfer = props.isBankTransfer,
      _a = props.onClickBack,
      onClickBack = _a === void 0 ? noop : _a;
  return /*#__PURE__*/React.createElement(Grid, {
    textAlign: "center",
    fontSize: "18px",
    gap: "6",
    justifyItems: "center"
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(SuccessIcon, null)), /*#__PURE__*/React.createElement(Text, {
    as: "h2",
    fontSize: "2xl",
    fontWeight: "bold"
  }, "\u0E02\u0E2D\u0E1A\u0E04\u0E38\u0E13\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19"), /*#__PURE__*/React.createElement(Message, {
    isBankTransfer: isBankTransfer
  }), /*#__PURE__*/React.createElement(VStack, {
    spacing: "4"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "lg",
    onClick: onClickBack,
    colorScheme: "brand"
  }, "\u0E01\u0E25\u0E31\u0E1A\u0E2A\u0E39\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E41\u0E14\u0E0A\u0E1A\u0E2D\u0E23\u0E4C\u0E14"), /*#__PURE__*/React.createElement(VStack, {
    spacing: "1",
    pt: "4"
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: "sm"
  }, "\u0E2B\u0E32\u0E01\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E2A\u0E07\u0E2A\u0E31\u0E22\u0E42\u0E1B\u0E23\u0E14\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D", ' ', /*#__PURE__*/React.createElement(Link, {
    href: "tel:020249119",
    display: "inline"
  }, "02-024-9119"), ' ', "\u0E2B\u0E23\u0E37\u0E2D", ' ', /*#__PURE__*/React.createElement(Link, {
    href: "mailto:support@ndatathoth.com",
    display: "inline"
  }, "support@ndatathoth.com")))));
};

var Message = function Message(props) {
  var isBankTransfer = props.isBankTransfer;
  var project = React.useContext(ProjectContext);

  if (isBankTransfer) {
    return /*#__PURE__*/React.createElement(Text, null, "\u0E40\u0E23\u0E32\u0E08\u0E30\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E22\u0E2D\u0E14\u0E42\u0E2D\u0E19\u0E41\u0E25\u0E30\u0E2A\u0E48\u0E07\u0E43\u0E1A\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E23\u0E31\u0E1A\u0E40\u0E07\u0E34\u0E19\u0E44\u0E1B\u0E22\u0E31\u0E07", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Link, {
      href: "mailto:" + project.email,
      display: "inline"
    }, project.email), ' ', "\u0E20\u0E32\u0E22\u0E43\u0E19 2 \u0E27\u0E31\u0E19\u0E17\u0E33\u0E01\u0E32\u0E23");
  }

  return /*#__PURE__*/React.createElement(Text, null, "\u0E40\u0E23\u0E32\u0E08\u0E30\u0E17\u0E33\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E41\u0E25\u0E30\u0E2A\u0E48\u0E07\u0E43\u0E1A\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E23\u0E31\u0E1A\u0E40\u0E07\u0E34\u0E19\u0E44\u0E1B\u0E22\u0E31\u0E07", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Link, {
    href: "mailto:" + project.email,
    display: "inline"
  }, project.email), ' ', "\u0E20\u0E32\u0E22\u0E43\u0E19 2 \u0E27\u0E31\u0E19\u0E17\u0E33\u0E01\u0E32\u0E23");
};

var SuccessIcon = function SuccessIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "126",
    height: "126",
    viewBox: "0 0 126 126"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M43 3v105l50-5c5.5 0 10-4.5 10-10V3L93 13 83 3 73 13 63 3 53 13 43 3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#444B54",
    d: "M93 16c-.8 0-1.5-.3-2.1-.9L83 7.2l-7.9 7.9c-1.2 1.2-3.1 1.2-4.2 0l-10-10c-1.2-1.2-1.2-3.1 0-4.2C62.1-.3 64-.3 65.1.9L73 8.8 80.9.9C82.1-.3 84-.3 85.1.9L93 8.8l7.9-7.9c1.2-1.2 3.1-1.2 4.2 0 1.2 1.2 1.2 3.1 0 4.2l-10 10c-.6.6-1.3.9-2.1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CADBEA",
    d: "M73 23H43v80h50V43c0-11-9-20-20-20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#444B54",
    d: "M43 35c-1.7 0-3-1.3-3-3V3c0-1.7 1.3-3 3-3s3 1.3 3 3v29c0 1.7-1.3 3-3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CADBEA",
    d: "M63 103V43c0-5.5 4.5-10 10-10s10 4.5 10 10v50c0 5.5 4.5 10 10 10H63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#444B54",
    d: "M93 106c-1.7 0-3-1.3-3-3s1.3-3 3-3c3.9 0 7-3.1 7-7V3c0-1.7 1.3-3 3-3s3 1.3 3 3v90c0 7.2-5.8 13-13 13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#444B54",
    d: "M93 106H73c-1.7 0-3-1.3-3-3s1.3-3 3-3h9c-1.3-2-2-4.4-2-7V43c0-3.9-3.1-7-7-7-1.7 0-3-1.3-3-3s1.3-3 3-3c7.2 0 13 5.8 13 13v50c0 3.9 3.1 7 7 7 1.7 0 3 1.3 3 3s-1.3 3-3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6EC6AF",
    d: "M63 49h50c5.5 0 10 4.5 10 10v44c0 5.5-4.5 10-10 10H33c-5.5 0-10-4.5-10-10l40-54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5E8DF",
    d: "M73 96c-8.284 0-15-6.716-15-15 0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15m40-37H55.593L33 89.5V103h80V59"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEF8F5",
    d: "M73 66c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#444B54",
    d: "M113 116H33c-7.2 0-13-5.8-13-13 0-1.7 1.3-3 3-3s3 1.3 3 3c0 3.9 3.1 7 7 7h80c3.9 0 7-3.1 7-7V59c0-3.9-3.1-7-7-7H73c-1.7 0-3-1.3-3-3s1.3-3 3-3h40c7.2 0 13 5.8 13 13v44c0 7.2-5.8 13-13 13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3 113V43c0-5.5 4.5-10 10-10h60c-5.5 0-10 4.5-10 10v70l-10 10-10-10-10 10-10-10-10 10-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#444B54",
    d: "M53 126c-.8 0-1.5-.3-2.1-.9l-7.9-7.9-7.9 7.9c-1.2 1.2-3.1 1.2-4.2 0l-7.9-7.9-7.9 7.9c-1.2 1.2-3.1 1.2-4.2 0-1.2-1.2-1.2-3.1 0-4.2l10-10c1.2-1.2 3.1-1.2 4.2 0l7.9 7.9 7.9-7.9c1.2-1.2 3.1-1.2 4.2 0l7.9 7.9 7-7V43c0-2.6.8-5 2-7H13c-3.9 0-7 3.1-7 7v70c0 1.7-1.3 3-3 3s-3-1.3-3-3V43c0-7.2 5.8-13 13-13h60c1.7 0 3 1.3 3 3s-1.3 3-3 3c-3.9 0-7 3.1-7 7v70c0 .8-.3 1.6-.9 2.1l-10 10c-.6.6-1.3.9-2.1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9EB9D3",
    d: "M48 56H18c-1.7 0-3-1.3-3-3s1.3-3 3-3h30c1.7 0 3 1.3 3 3s-1.3 3-3 3zM18 71c-.8 0-1.6-.3-2.1-.9-.6-.5-.9-1.3-.9-2.1s.3-1.6.9-2.1c1.1-1.1 3.1-1.1 4.2 0 .6.6.9 1.3.9 2.1s-.3 1.6-.9 2.1l-.4.4c-.2.1-.3.2-.5.3-.2.1-.4.1-.6.2H18zm30 0H38c-1.7 0-3-1.3-3-3s1.3-3 3-3h10c1.7 0 3 1.3 3 3s-1.3 3-3 3zm0 15H18c-1.7 0-3-1.3-3-3s1.3-3 3-3h30c1.7 0 3 1.3 3 3s-1.3 3-3 3zm0 15c-.8 0-1.6-.3-2.1-.9-.6-.6-.9-1.3-.9-2.1 0-.2 0-.4.1-.6 0-.2.1-.4.2-.6.1-.2.2-.3.3-.5.1-.2.2-.3.4-.5 1.1-1.1 3.1-1.1 4.2 0 .6.6.9 1.3.9 2.1s-.3 1.6-.9 2.1l-.4.4c-.2.1-.3.2-.5.3-.2.1-.4.1-.6.2-.3.1-.5.1-.7.1z"
  })));
};